export { consumptionProfile } from './consumptionProfile';
export { alert } from './alert';
export { inputAlert } from './inputAlert';
export { inputSuccess } from './inputSuccess';
export { aprender } from './aprender';
export { arrowdown } from './arrowdown';
export { arrowup } from './arrowup';
export { backarrow } from './backarrow';
export { bloqueio } from './bloqueio';
export { broadband } from './broadband';
export { bell } from './bell';
export { c2c } from './c2c';
export { calendar } from './calendar';
export { caret } from './caret';
export { cart } from './cart';
export { celular } from './celular';
export { callDetails } from './callDetails';
export { charts } from './charts';
export { chat } from './chat';
export { check } from './check';
export { cleanCheck } from './cleancheck';
export { close } from './close';
export { combo } from './combo';
export { comprar } from './comprar';
export { conexao } from './conexao';
export { configuracao } from './configuracao';
export { contract } from './contract';
export { desconto } from './desconto';
export { enviar } from './enviar';
export { facebook } from './facebook';
export { featAntivirus } from './feat-antivirus';
export { featCertificate } from './feat-certificate';
export { featCloud } from './feat-cloud';
export { featModem } from './feat-modem';
export { featWifi } from './feat-wifi';
export { googlePlus } from './google-plus';
export { help } from './help';
export { historico, historico as history } from './historico';
export { info } from './info';
export { invoice } from './invoice';
export { invoiceOld } from './invoiceOld';
export { internet } from './internet';
export { landline } from './landline';
export { landlineInstallation } from './landlineInstallation';
export { like } from './like';
export { loading } from './loading';
export { localizationPin } from './localization_pin';
export { lupa } from './lupa';
export { lupaThin } from './lupa-thin';
export { mobile } from './mobile';
export { money } from './money';
export { oi } from './oi';
export { oiPlay } from './oiPlay';
export { paper } from './paper';
export { people } from './people';
export { plus } from './plus';
export { power } from './power';
export { productBandaLarga } from './product-bandalarga';
export { productFixo } from './product-fixo';
export { productPos } from './product-pos';
export { productTvHd } from './product-tv-HD';
export { productTv } from './product-tv';
export { protecao } from './protecao';
export { protocol } from './protocol';
export { recompensa } from './recompensa';
export { redefinir } from './redefinir';
export { rechargeOld } from './rechargeOld';
export { seguranca } from './seguranca';
export { services } from './services';
export { suporte } from './suporte';
export { transferir } from './transferir';
export { tv } from './tv';
export { tvhd } from './tvhd';
export { twitter } from './twitter';
export { user } from './user';
export { youtube } from './youtube';
export { notes } from './notes';
export { tvSignal } from './tvSignal';
export { IconCameraErro } from './portal-camera-erro';
export { IconCameraRiscada } from './portal-camera-riscada';
export { IconSemFoto } from './portal-sem-foto';
